import { render, staticRenderFns } from "./PpcHero.vue?vue&type=template&id=71c8b132&scoped=true&"
import script from "./PpcHero.vue?vue&type=script&lang=js&"
export * from "./PpcHero.vue?vue&type=script&lang=js&"
import style0 from "./PpcHero.vue?vue&type=style&index=0&id=71c8b132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8b132",
  null
  
)

export default component.exports